import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { CalendarEvent } from 'src/meetings/models';
import { meetingsQueryKey } from 'src/meetings/hooks/useScopedMeetings';
import type { MeetingScope } from 'src/meetings/scope';

type AssignSpeakerParticipant =
  | { participantType: 'CLIENT'; clientId: string }
  | { participantType: 'EXTERNAL'; name: string; description: string };

export type AssignSpeakerBody = {
  speakerLabel: string;
  participant: AssignSpeakerParticipant;
};

export const useAssignSpeaker = (scope: MeetingScope, eventId: string) => {
  const queryClient = useQueryClient();

  return useMutation<{ data: CalendarEvent }, Error, AssignSpeakerBody>({
    mutationFn: body =>
      api.post<CalendarEvent>(`calendar-events/${eventId}/transcript/assign-speaker`, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: meetingsQueryKey(scope) });
      queryClient.invalidateQueries({ queryKey: ['calendar-events', eventId, 'transcript'] });
    },
  });
};
